import { render, staticRenderFns } from "./user-2.vue?vue&type=template&id=091d6ae0&"
import script from "./user-2.vue?vue&type=script&lang=js&"
export * from "./user-2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('091d6ae0')) {
      api.createRecord('091d6ae0', component.options)
    } else {
      api.reload('091d6ae0', component.options)
    }
    module.hot.accept("./user-2.vue?vue&type=template&id=091d6ae0&", function () {
      api.rerender('091d6ae0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/user-2.vue"
export default component.exports